module.exports = __webpack_public_path__ + "img/fork-knife.75273449.svg";